// Burst collapsing for the activity feed (#1160, #1261, decision
// 2026-10-23): a work phase makes dozens of entries with an AI result right
// behind each — lappu, analyysi, lappu, analyysi. The tile must not scroll
// with it. Same-kind events merge into one counted line even when other
// kinds land between them, so the room sees two or three lines whose
// counters climb; a new line appears only when something different starts.
// The backend counts the backfill into bursts by the same rule (#1394,
// loadActivity in apps/backend/src/routes/dashboard.js); this merges the
// live events since the last fetch into them. Items must arrive newest-first.

// Keep equal to FEED_BURST_GAP in apps/backend/src/routes/dashboard.js
export const FEED_BURST_GAP_MS = 5 * 60000;

/**
 * Collapse items into {at, kind, count} groups, newest first. An item is a
 * single event {at, kind} or a counted burst {at, kind, count, oldestAt}.
 * It joins the open group of its kind when its newest moment is within
 * gapMs of that group's oldest, wherever that group sits in the list;
 * otherwise it opens a new group, as long as the limit leaves room — beyond
 * the limit an item can still grow an open group but never adds a line.
 * `at` is the group's newest moment.
 */
export function groupFeedEvents(items, { gapMs = FEED_BURST_GAP_MS, limit = 10 } = {}) {
  const groups = [];
  for (const item of items || []) {
    const at = new Date(item.at).getTime();
    const oldestMs = item.oldestAt ? new Date(item.oldestAt).getTime() : at;
    const count = item.count || 1;
    const open = groups.find((g) => g.kind === item.kind && g.oldestMs - at <= gapMs);
    if (open) {
      open.count += count;
      open.oldestMs = oldestMs;
    } else if (groups.length < limit) {
      groups.push({ at: item.at, kind: item.kind, count, oldestMs });
    }
  }
  return groups.map(({ at, kind, count }) => ({ at, kind, count }));
}
